// import React from "react";
// import { ProgressTab } from "../../../../components";

// const TabsList = () => {
//   const tabCount = 5;

//   const TabsMenu = Array.from({ length: tabCount }, (_, i) => ({
//     title: `Tab-${i + 1}`,
//     page: `page-${i + 1}`,
//   }));

//   return (
//     <div className="w-full flex flex-1 flex-col overflow-auto">
//       {TabsMenu.map((_, tabIndex) =>
//         TabsMenu.map((_, slideIndex) =>
//           slideIndex >= tabIndex ? (
//             <div key={`tab-${tabIndex}-slide-${slideIndex}`}>
//               <ProgressTab
//                 tabs={TabsMenu}
//                 initialActiveTab={tabIndex}
//                 initialActiveSlide={slideIndex}
//               />
//               <p>
//                 Tab {tabIndex + 1} - Slide {slideIndex + 1}
//               </p>
//             </div>
//           ) : null
//         )
//       )}
//     </div>
//   );
// };

// export default TabsList;

import React from "react";
import ProgressTabList from "./TabsList/ProgressTabList";
import { NewTab, PageTab } from "../../../../components";
import PageTabList from "./TabsList/PageTabList";
import VerticalTabsList from "./TabsList/VerticalTabsList";

const TabsList = () => {
  const tabList = [
    {
      title: "Page Tab 1",
      page: <PageTabList />,
      type: "main",
    },
    {
      title: "Progress Tab",
      page: <ProgressTabList />,
      type: "main",
    },
    {
      title: "Vertical Tab",
      page: <VerticalTabsList />,
      type: "main",
    },
  ];
  return (
    <div className="w-full p-2 flex flex-1 overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="tabs-list"
      />
    </div>
  );
};

export default TabsList;
